import clsx from 'clsx';
import formatNumber from '../utils/formatNumber';

export default function Tabs({ tabs, activeTab, onChange }) {
  return (
    <div>
      <div className='sm:hidden'>
        <label htmlFor='tabs' className='sr-only'>
          Select a tab
        </label>
        <select
          id='tabs'
          name='tabs'
          className='block w-full rounded-md border-gray-900 py-2 pl-3 pr-10 text-base focus:border-primary-500 focus:outline-none focus:ring-primary-500 sm:text-sm bg-gray-900'
          defaultValue={activeTab}
          value={activeTab}
          onChange={(e) => onChange(e.target.value)}
        >
          {tabs.map((tab) => (
            <option value={tab.id} key={tab.id}>
              {tab.name} {typeof tab.count === 'number' ? `(${formatNumber(tab.count)})` : ''}
            </option>
          ))}
        </select>
      </div>
      <div className='hidden sm:block'>
        <div className='border-b border-gray-700'>
          <nav className='-mb-px flex space-x-8' aria-label='Tabs'>
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => onChange(tab.id)}
                className={clsx(
                  'flex whitespace-nowrap border-b-2 px-1 py-4 font-semibold hover:border-primary-500 hover:text-gray-100 transition duration-200',
                  activeTab === tab.id ? 'border-primary-500 text-primary-500' : 'text-gray-300 border-transparent'
                )}
              >
                {tab.name}
                {typeof tab.count === 'number' && (
                  <span className='ml-3 hidden rounded-full bg-gray-900 px-2.5 py-0.5 font-semibold text-gray-100 md:inline-block'>
                    {formatNumber(tab.count)}
                  </span>
                )}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
}
